/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m14.6924 20.2616c.553 0 1 .447 1 1 0 .552-.447 1-1 1h-11.738c-1.629 0-2.954-1.327-2.954-2.957v-14.348c0-1.63 1.325-2.957 2.954-2.957h23.478c1.632 0 2.959 1.327 2.959 2.957v7.174c0 .552-.447 1-1 1s-1-.448-1-1v-6.922l-12.074 9.66c-.183.146-.404.219-.625.219s-.442-.073-.625-.219l-12.067-9.655v14.091c0 .527.427.957.954.957zm0-7.455 11.009-8.807h-22.017zm17.015 4.484c.39.391.39 1.023 0 1.414l-9.786 9.786c-.083.084-.185.145-.292.194-.026.012-.05.023-.077.033-.021.007-.041.021-.063.027l-4.566 1.304c-.089.026-.182.039-.274.039-.262 0-.517-.103-.707-.293-.257-.257-.354-.633-.255-.982l1.305-4.566c.007-.023.019-.043.028-.065.009-.025.02-.048.031-.073.05-.108.111-.209.196-.294l9.785-9.785c.39-.39 1.023-.39 1.414 0zm-3.316 1.902 1.195-1.195-1.847-1.847-1.195 1.195zm-9.942 7.238-.344 1.201 1.201-.343zm2.765-.061 5.763-5.763-1.847-1.847-5.762 5.763z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;